import { createContext } from "react";
import { FoodManagementContextType } from "../types/foodManagement";

export const FoodManagementContext = createContext<
  FoodManagementContextType | undefined
>(undefined);
